import axios from "axios";

/**
 * Shared axios instance with global 401 handling for authenticated API calls.
 * Uses cookie credentials for auth.
 */
const axiosClient = axios.create({
  withCredentials: true,
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest =
      typeof error.config?.url === "string" &&
      (error.config.url.includes("/login") || error.config.url.includes("/api/login"));
    if (error.response?.status === 401 && !isLoginRequest) {
      window.dispatchEvent(new Event("auth-token-expired"));
    }
    if (error.response?.status === 403) {
      const d = error.response?.data;
      if (d?.forceLogout || d?.code === "ADMIN_ROLE_REVOKED") {
        window.dispatchEvent(
          new CustomEvent("auth-token-expired", {
            detail: {
              sessionNotice: typeof d?.error === "string" ? d.error : undefined,
            },
          })
        );
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
